import Main from '../views/registry/Main';
import Specialties from '../views/registry/Specialties';
import Employees from '../views/registry/Employees';
import Employee from '../views/registry/Employee';
import Departments from '../views/registry/Departments';
import Doctors from '../views/registry/Doctors';
import Doctor from '../views/registry/Doctor';
import Schedule from '../views/registry/Schedule';
import Organization from '../views/registry/Organization';
import Patients from '../views/registry/Patients';
import CardPatient from '../views/registry/pages/CardPatient';
import Queue from '../views/registry/pages/Queue';

export default [
  {
    path: '',
    name: 'registry.main',
    component: Main
  },
  {
    path: 'organization',
    name: 'registry.organization',
    component: Organization
  },
  {
    path: 'specialties',
    name: 'registry.specialties',
    component: Specialties
  },
  {
    path: 'departments',
    name: 'registry.departments',
    component: Departments
  },
  {
    path: 'employees',
    name: 'registry.employees',
    component: Employees
  },
  {
    path: 'employee',
    name: 'registry.employee.create',
    component: Employee
  },
  {
    path: 'employee/:uuid',
    name: 'registry.employee.update',
    component: Employee
  },
  {
    path: 'doctors',
    name: 'registry.doctors',
    component: Doctors
  },
  {
    path: 'doctor',
    name: 'registry.doctor.create',
    component: Doctor
  },
  {
    path: 'doctor/:uuid',
    name: 'registry.doctor.update',
    component: Doctor
  },
  {
    path: 'schedule',
    name: 'registry.schedule',
    component: Schedule
  },
  {
    path: 'queue',
    name: 'registry.queue',
    component: Queue
  },
  {
    path: 'patients',
    name: 'registry.patients',
    component: Patients,
  },
  {
    path: 'patient/',
    name: 'registry.patient.card.create',
    component: CardPatient
  },
  {
    path: 'patient/:uuidPatient',
    name: 'registry.patient.card',
    component: CardPatient,
    meta: {
      resources: [
        {
          type: 'organization',
          roles: ['orgadmin', 'doctor']
        }]
      }
  }
];
